<script setup lang="ts">
  import TheToast from '@/components/the-toast.vue'
  import { useInitApp } from './models/app'

  const { init } = useInitApp()
  init()
</script>

<template>
  <app-router-view />
  <the-toast />
</template>
